export default __webpack_public_path__ + "static/media/1A.03b13326.svg";